import script from "./AppBtn.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBtn.vue?vue&type=script&setup=true&lang=ts"

import "./AppBtn.vue?vue&type=style&index=0&id=9efee300&lang=scss"

const __exports__ = script;

export default __exports__